<div class="bf-gallery">

  <app-hero></app-hero>

  <app-gallery-grid></app-gallery-grid>

</div>
